import {
  Button,
  BUTTON_VARIANT_SECONDARY,
  Grid,
  GridCell,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text,
  TEXT_VARIANT_BOLD
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useRecoilValue, useResetRecoilState } from 'recoil'

import {
  FILTER_TYPE_ACTIVITY,
  FILTER_TYPE_ANAGRAPHIC,
  FILTER_TYPE_ENGAGEMENT,
  FILTER_TYPE_GEOLOCATION
} from 'Constants'

import { notifyParent } from 'mailup-react-helpers'
import { modalFilterDetailState } from '../recoil/states/page'

export const ModalFilterDetails = () => {
  const intl = useIntl()
  const { show, id, type, name, description } = useRecoilValue(
    modalFilterDetailState
  )

  const resetModal = useResetRecoilState(modalFilterDetailState)

  const handleClickConfirm = () => {
    let href
    switch (type) {
      case FILTER_TYPE_ACTIVITY:
        href = `filters_app_redirector.aspx?r=edit_activity:${id}`
        break
      case FILTER_TYPE_GEOLOCATION:
        href = `filters_app_redirector.aspx?r=edit_geolocation:${id}`
        break
      case FILTER_TYPE_ANAGRAPHIC:
        href = `filters_app_redirector.aspx?r=edit_profile:${id}`
        break
      case FILTER_TYPE_ENGAGEMENT:
        href = `filters_app_redirector.aspx?r=edit_engagement:${id}`
        break
    }

    if (href) {
      notifyParent('redirectMainFrame', [href])
      return
    }

    resetModal()
  }

  return (
    <Modal
      show={show}
      onClose={resetModal}
      className='b-modal--filter-details'
      data-mu-test='modal-filter-details'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.SearchRecipients.EditFilterFilterTitle'
        })}
      />

      <ModalBody>
        <Grid cols={12}>
          <GridCell span={3}>
            <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
              {intl.formatMessage({
                id: 'Load.SearchRecipients.EditFilterFilterType'
              })}
            </Text>
          </GridCell>
          <GridCell span={9}>
            <Text htmlElement='span'>{type}</Text>
          </GridCell>
          <GridCell span={3}>
            <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
              {intl.formatMessage({
                id: 'Load.SearchRecipients.EditFilterFilterName'
              })}
            </Text>
          </GridCell>
          <GridCell span={9}>
            <Text htmlElement='span'>
              {id} - {name}
            </Text>
          </GridCell>
          <GridCell span={3}>
            <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
              {intl.formatMessage({
                id: 'Load.SearchRecipients.EditFilterFilterConditions'
              })}
            </Text>
          </GridCell>
          <GridCell span={9}>
            <Text htmlElement='span'>{description}</Text>
          </GridCell>
        </Grid>
      </ModalBody>

      <ModalFoot>
        <Button kind={BUTTON_VARIANT_SECONDARY} onClick={resetModal}>
          {intl.formatMessage({
            id: 'Load.SearchRecipients.EditFilterCloseButton'
          })}
        </Button>
        <Button kind={BUTTON_VARIANT_SECONDARY} onClick={handleClickConfirm}>
          {intl.formatMessage({
            id: 'Load.SearchRecipients.EditFilterEditButton'
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}
